import packageJSON from '../package.json'

export const MOCK_PORT = 3004
export const MOCK_URL = `http://localhost:${MOCK_PORT}`
export const DO_NOT_LOGIN = process.env.REACT_APP_TEST_MODE || false

const apiUrl = process.env.REACT_APP_DEV_MODE || process.env.STORYBOOK_DEV ? MOCK_URL : process.env.REACT_APP_API_URL

const adalConfig = {
  tenant: process.env.REACT_APP_ADAL_TENANT || 'grupaccc.onmicrosoft.com',
  clientId: process.env.REACT_APP_ADAL_CLIENT_ID || '25c4dc8f-8621-42bb-8a35-66cc5b4e57e2',
  endpoints: {
    api: process.env.REACT_APP_ADAL_API_URL || 'https://grupaccc.onmicrosoft.com/UtargiDevWeb',
  },
  postLogoutRedirectUri: process.env.REACT_APP_ADAL_LOGOUT_URI,
  redirectUri: process.env.REACT_APP_ADAL_REDIRECT_URI,
  cacheLocation: process.env.REACT_APP_ADAL_CACHE || 'localStorage',
}

// NOTE: Please update `workbox-config.js` file once there is a change in API endpoint
export default {
  adalConfig,
  analyticsId: process.env.REACT_APP_ANALYTICS_ID || 'none',
  api: {
    bugReport: `${apiUrl}/BugReport`,
    channels: `${apiUrl}/Channels`,
    channelsFloorspace: `${apiUrl}/ChannelsFloorspace`,
    clusters: `${apiUrl}/Clusters`,
    companies: `${apiUrl}/Companies`,
    countries: `${apiUrl}/Countries`,
    districtResults: `${apiUrl}/DistrictResults`,
    ecoms: `${apiUrl}/Ecoms`,
    group: `${apiUrl}/Group`,
    login: `${apiUrl}/login`,
    omsOrigins: `${apiUrl}/OmsOrigins`,
    owners: `${apiUrl}/Owners`,
    rankingCountries: `${apiUrl}/RankingCountries`,
    rankingDistricts: `${apiUrl}/RankingDistricts`,
    rankingHourlyCountries: `${apiUrl}/RankingHourlyCountries`,
    rankingHourlyStores: `${apiUrl}/RankingHourlyStores`,
    rankingRegions: `${apiUrl}/RankingRegions`,
    rankingStores: `${apiUrl}/RankingStores`,
    regionResults: `${apiUrl}/RegionResults`,
    saleTypes: `${apiUrl}/SaleTypes`,
    store: `${apiUrl}/Store`,
    storeReplenishment: `${apiUrl}/StoreReplenishment`,
    storeResult: `${apiUrl}/StoreResult`,
    stores: `${apiUrl}/Stores`,
    storeTraffic: `${apiUrl}/StoreTraffic`,
    system: `${apiUrl}/System`,
    url: apiUrl,
    user: `${apiUrl}/User`,
  },
  build: process.env.REACT_APP_BUILD_VERSION || '2430',
  defaultLanguage: 'pl',
  environment: process.env.NODE_ENV,
  name: packageJSON.name,
  sentryUrl: 'https://cbfbb78ca62a4bcc87cf27e7df82f561@o518518.ingest.sentry.io/5715811',
  tracesSampleRate: parseFloat(process.env.REACT_APP_TRACES_SAMPLE_RATE || '') || 1.0,
  version: packageJSON.version,
}
